import HealingIcon from './HealingIcon';

export default HealingIcon;
export { HealingIcon };
